import { gql } from '@grandvisionhq/graphql';
import { appointmentFragment } from '../../../fragments/appointment.js';

const CANCEL_APPOINTMENT_BY_TOKEN = gql`
  mutation CancelAppointmentByToken($token: String!, $cancellationReason: String) {
    cancelAppointmentByToken(token: $token, cancellationReason: $cancellationReason) {
      ...AppointmentFragment
    }
  }
  ${appointmentFragment}
`;

export { CANCEL_APPOINTMENT_BY_TOKEN };
//# sourceMappingURL=cancel-appointment-by-token.js.map
